<stx-spinner [showSpinner]="showSpinner">
  @if (!hideNavigation) {
  <div class="content-all">
    <stx-navigation class="not-print"></stx-navigation>
    <div class="content">
      <router-outlet></router-outlet>
    </div>
    <stx-footer class="not-print"></stx-footer>
  </div>
  } @else {
  <router-outlet></router-outlet>
  }
</stx-spinner>
